import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SubscribePageFooter = (props) => {
    const { successMessage, errorMessage } = props;
    return ((!!successMessage || !!errorMessage) && (_jsxs("div", { className: "rich-text__wrapper py-4", children: [!!successMessage && _jsx("p", { children: successMessage }), !!errorMessage && _jsx("p", { className: "subscribe__error-message", children: errorMessage })] })));
};
export default SubscribePageFooter;
